var _circle, _ellipse, _ellipse2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegularFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5001,
    cy: 36.9906,
    r: 36.9906,
    fill: "#F9C304"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.0095,
    cy: 30.4812,
    rx: 3.5,
    ry: 6.5,
    fill: "#685615"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.0095,
    cy: 30.4812,
    rx: 3.5,
    ry: 6.5,
    fill: "#685615"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5095 47.168H38.3331L54.5283 47.168",
    stroke: "#685615",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegularFace);
export default __webpack_public_path__ + "static/media/regular_face.02c298964548d619725c68d4cfd29857.svg";
export { ForwardRef as ReactComponent };